interface LayoutOptions {
  header: boolean;
  subscribe: boolean;
  footer: boolean;
  mobileNavbar: boolean;
}

type LayoutFilterRoute = Record<
  string,
  {
    desktop?: Partial<LayoutOptions>;
    mobile?: Partial<LayoutOptions>;
  }
>;

const LAYOUT_FILTER_ROUTES: LayoutFilterRoute = {
  '/checkout/': {
    desktop: {
      header: false,
      mobileNavbar: false,
    },
    mobile: {
      header: false,
      mobileNavbar: false,
    },
  },
} as const;

const DEFAULT_LAYOUT_OPTIONS: LayoutOptions = {
  header: true,
  subscribe: true,
  footer: true,
  mobileNavbar: true,
};

export function getLayoutOptions(pathname: string, isMobile = false): LayoutOptions {
  const route = LAYOUT_FILTER_ROUTES[pathname];

  // Fallback strategy:
  // 1. If the exact device variant exists, use it.
  // 2. Otherwise, fall back to the other variant (desktop -> mobile or vice-versa).
  let specific: Partial<LayoutOptions> | undefined;

  if (route) {
    specific = isMobile ? (route.mobile ?? route.desktop) : (route.desktop ?? route.mobile);
  }

  return {
    ...DEFAULT_LAYOUT_OPTIONS,
    ...specific,
  };
}
